import { Component, input } from '@angular/core';
import type { ProductUsp } from '@legacy/common-ui-models';
import type { ToolTip } from '@legacy/common-ui-utility-components';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { ToolTipComponent } from '@legacy/common-ui-utility-components';

@Component({
  selector: 'wl-generic-usps[usps]',
  templateUrl: './generic-usps.component.html',
  styleUrls: [],
  standalone: true,
  imports: [CSCaptureDirective, FaIconComponent, ToolTipComponent],
})
export class GenericUspsComponent {
  readonly usps = input.required<ProductUsp[]>();

  tooltip(usp: ProductUsp): ToolTip {
    return {
      description: usp.tooltip,
    };
  }
}
